(function($) {

  $(window).on('load', function (){
    gsap.registerPlugin(ScrollToPlugin);
    // const $frameBlue = document.querySelector('.page_transition.blue');
    // const $framePink = document.querySelector('.page_transition.pink');
    // const $main = document.querySelector('.main');
    // const $header = document.querySelector('.header');
    //const _bannerHome = $('.page_banner_home').not('.page_banner_home_v2');
    // const h1 = $('.page_banner_home h1 span');
    //const we = $('.page_banner_home h1 b');
    // var tl = gsap.timeline({paused:true});

    // tl.set($header, {autoAlpha: 0})
    // tl.set($main, {autoAlpha:0, y:'100%'})
    // tl.to($frameBlue, 1, {height: '100%', ease:Back.easeOut})
    // tl.to($framePink, 1, {height: '100%', ease:Back.easeOut},.1)
    // tl.to($framePink, 1, {y: '-100%', ease:Back.easeOut},.8)
    // tl.to($frameBlue, 1, {y: '-100%', ease:Back.easeOut},.9)
    // tl.to($main, .8, {autoAlpha:1, y:0, ease:Power1.easeOut},.6)
    // tl.to($header, .8, {autoAlpha:1, ease:Power1.easeOut}, .9)

    /*if(_bannerHome.length > 0){
      tl.to(h1, {duration: .5, text:"", delay: 1})
      tl.to(we, {duration: .4, opacity:1})
      tl.to(h1, {duration: .8, text:"Dream", ease: "steps(5)"})
      tl.to(h1, {duration: .4, text:"", delay: 1})
      tl.to(h1, {duration: .8, text:"Build", ease: "steps(5)"})
      tl.to(h1, {duration: .4, text:"", delay: 1})
      tl.to(h1, {duration: .8, text:"Launch", ease: "steps(6)"})
      tl.to(h1, {duration: .4, text:"", delay: 1})
      tl.to(h1, {duration: 2, text:"<b>a</b><b>r</b><b>e</b> digital <br/> experience <b>m</b><b>a</b><b>k</b><b>e</b><b>r</b><b>s</b> !", ease: "steps(32)"})
    }*/
    /*if(window.location.hash){
      var _hash = window.location.hash;
      if($(_hash).length > 0){
        window.scrollTo(0,0);
        var _offset = $(_hash).offset().top - 100;
        tl.to(window, {duration: .1, scrollTo: _offset, ease: "power3.inOut" });
      }
    }*/
    // tl.set($frameBlue, {height: 0, autoAlpha: 0, y:0})
    // tl.set($framePink, {height: 0, autoAlpha: 0, y:0})

    // tl.play(0);

    //const $div = document.querySelector('#accompagnement_conseil');
    //gsap.to($div, {duration: 2, scrollTo: 250});
    //gsap.to(window, {duration: 2, scrollTo: 400, ease:Power1});
  });

  $(document).ready(function() {
    var app = {
      isMobile: false,
      isTablet: false,
      breakPointMenuBurger: 1200,
      breakPointMaxTablet: 1024,
      breakPointTablet: 992,
      breakPointMobile: 768,
      init: function() {

        app.detectMobile();

        app.fixedHeader();
        app.burgerMenu();

        app.animateLines();
        app.animateIcons();
        // app.animateIconsBig();
        // app.animateClientCase();
        app.animateList();
        //app.animateCases();
        // app.animateImgTest();
        //app.animateCTA();
        //app.animateCTA2();
        // -- test anim
        app.animateTeaserAgence();
        app.animateNumberAgence();
        app.animateLabContent();
        app.animateCaseContent();
        app.animateIconMouse();
        app.animateLogo();
        app.animateContent();
        app.animateContentIcons();
        //app.animateTestimonial();
        app.animateBlogTags();

        app.swiperRealisation();
        app.swiperProjects();
        app.swiperExpertise();
        //app.swiperActualites();
        app.swiperCases();
        app.swiperLogo();
        app.swiperArticles();

        // app.pageTransition();

        //app.bannerHomePage();

        //app.teamHover();

        $(document).ajaxComplete(function(e, x, s){
          app.animateContent();
        });

      },

      bannerHomePage: function (){

        if($('.swiper_homepage_banner').length > 0){

          const breakpoint = window.matchMedia( '(min-width:992px)' );

          let mySwiper;
          let refreshIntervalId;

          const breakpointChecker = function() {
            if ( breakpoint.matches === true ) {
              if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
              $('.swiper_homepage_banner .swiper-wrapper').addClass('row');
              $('.swiper_homepage_banner .col').first().addClass('active');
              changeBackground($('.swiper_homepage_banner .col').first().data('image'));
              slideDesktop(0);
              slideHoverDesktop();
              return;
            } else if ( breakpoint.matches === false ) {
              clearInterval(refreshIntervalId);
              $('.swiper_homepage_banner .swiper-wrapper').removeClass('row');
              $('.swiper_homepage_banner .col').removeClass('active');
              changeBackground($('.swiper_homepage_banner .col').first().data('image'));
              return enableSwiper();
            }
          };

          const changeBackground = function (image){
            $('.page_banner_home_v2').css('background-image', 'url('+image+')');
          }

          const slideHoverDesktop = function (){
            $('.swiper_homepage_banner .col').hover(
              function (){
                clearInterval(refreshIntervalId);
                $('.swiper_homepage_banner .col').removeClass('active');
                $(this).addClass('active2');
                changeBackground($(this).data('image'));
              }, function (){
                $('.swiper_homepage_banner .col').removeClass('active2');
                //$(this).addClass('active');
                var cols = $('.swiper_homepage_banner .col');
                var index = cols.index(this);
                if(index == 2){
                  $('.swiper_homepage_banner .col').first().addClass('active');
                  changeBackground($('.swiper_homepage_banner .col').first().data('image'));
                  slideDesktop(0);
                }else{
                  $('.swiper_homepage_banner .col').eq((index+1)).addClass('active');
                  changeBackground($('.swiper_homepage_banner .col').eq((index+1)).data('image'));
                  slideDesktop((index+1));
                }
              }
            )
          }

          const slideDesktop = function (index){
            var $elements = $('.swiper_homepage_banner .col');
            var total_elements = $elements.length;
            var element_with_class = index;
            refreshIntervalId = window.setInterval( function () {
              $elements.eq(element_with_class).removeClass('active');
              element_with_class += 1;
              if ( element_with_class === total_elements ) {
                element_with_class = 0;
              }
              $elements.eq(element_with_class).addClass('active');
              changeBackground($elements.eq(element_with_class).data('image'));
            }, 8000 );
          }

          const enableSwiper = function() {
            mySwiper = new Swiper('.swiper_homepage_banner', {
              init: false,
              loop: false,
              pagination: {
                el: '.swiper_homepage_banner_pagination.swiper-pagination',
                type: 'bullets',
                bulletActiveClass: 'active'
              },
              speed: 1000,
              autoplay: {
                delay: 8000,
                disableOnInteraction: false
              },
              breakpoints: {
                991: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
                767: {
                  slidesPerView: 1,
                  spaceBetween: 30,
                }
              }
            });
            mySwiper.on('transitionStart', function (){
              let index = mySwiper.activeIndex;
              let current_image = this.slides[index].dataset.image;
              changeBackground(current_image);
            });
            mySwiper.on('paginationUpdate', function (swiper, paginationEl){
              let index = mySwiper.realIndex;
              $(paginationEl).find('.active').removeClass('active');
              $(paginationEl).find('.active2').removeClass('active2');
              window.setTimeout(function(){
                $(swiper.pagination.bullets[index]).addClass('active2');
              }, 1000);
            });

            mySwiper.init();


          };
          breakpoint.addEventListener('change', breakpointChecker);
          breakpointChecker();

        }

      },

      animateTestimonial: function (){
        gsap.registerPlugin(SplitText);
        gsap.registerPlugin(ScrollTrigger);
        const splitTimeline = gsap.timeline({
          scrollTrigger: {
            trigger: ".testimonial_banner",
            start: "top 80%",
            end: "bottom 10%",
            onToggle: self => gsap.to(".testimonial_text", {opacity: self.isActive ? 1 : 0}),
            //toggleActions: "restart pause resume none",
            toggleActions: "play none none none",
          }
        });

        const split = new SplitText(".testimonial_text");
        splitTimeline.from(split.chars, {
          duration: 1,
          opacity: 0,
          x: "random(-500, 500)",
          y: "random(-500, 500)",
          z: "random(-500, 500)",
          scale: .1,
          yoyo: true,
          stagger: 0.02
        });

      },

      animateBlogTags: function () {
        const _blogPagination = document.querySelector(".row-articles nav[role='navigation'].pager")??false;
        const _tagsContainer = document.querySelector(".row-terms")??false;

        if (!_blogPagination && !_tagsContainer) return;

        function setTagsContainerWidth() {
          const computedStyles = getComputedStyle(_tagsContainer.parentElement);
          const widthWithoutPadding = _tagsContainer.parentElement.clientWidth - parseFloat(computedStyles.paddingLeft) - parseFloat(computedStyles.paddingRight);
  
          _tagsContainer.style.width = `${widthWithoutPadding}px`;
        }
        setTagsContainerWidth();
        window.addEventListener("resize", () => {
          setTagsContainerWidth();
        })

        gsap.registerPlugin(ScrollTrigger);

        gsap.to(_tagsContainer, {
          opacity: 0,
          scrollTrigger: {
            trigger: _blogPagination,
            start: '-=150 bottom',
            end: '+=300',
            scrub: true,
            markers: false,
            toggleActions: 'play none play none',
            onUpdate: (self) => onUpdate(self)
          }
        });

        function onUpdate(animation) {
          const progress = animation.progress;
          
          progress > 0.75
            ? (_tagsContainer.style.pointerEvents = "none")
            : _tagsContainer.style.removeProperty("pointer-events");
        }
      },

      animateCTA: function (){
        gsap.registerPlugin(SplitText);
        $(".cta").not('.pink, .pink2').each(function(i,e) {
          var self = $(this),
            cta = self,
            ctatxtSplit = new SplitText(cta, {type:"chars"}),
            ctatxtChars = ctatxtSplit.chars,
            ctaTL = new gsap.timeline({paused:true});
          gsap.set(self, {perspective: 400});
          ctaTL.staggerTo(ctatxtChars, 0.25, { color: '#F11D58', ease: Back.easeOut }, 0.02);
          e.hoverTl = ctaTL;
          self.hover(function(){
            ctaTL.play();
          }, function(){
            ctaTL.reverse();
          });
        });
      },

      animateCTA2: function (){
        gsap.registerPlugin(SplitText);
        $(".cta.pink2").each(function(i,e) {
          var self = $(this),
            cta = self,
            ctatxtSplit = new SplitText(cta, {type:"chars"}),
            ctatxtChars = ctatxtSplit.chars,
            ctaTL = new gsap.timeline({paused:true});
          gsap.set(self, {perspective: 400});
          ctaTL.staggerTo(ctatxtChars, 0.25, { color: '#000a21', ease: Back.easeOut }, 0.015);
          e.hoverTl = ctaTL;
          self.hover(function(){
            ctaTL.play();
          }, function(){
            ctaTL.reverse();
          });
        });
      },

      animateTeaserAgence: function(){
        const _teaser = $('.agence.teaser');

        if(_teaser.length > 0){
          gsap.registerPlugin(ScrollTrigger);

          ScrollTrigger.batch(_teaser, {
            onEnter: batch => gsap.to(batch, {opacity: 1, scale: 1, stagger: 0.15, duration: 1, overwrite: true}),
          });
        }
      },

      animateNumberAgence: function(){
        const _agenceNumberContainer = $('.paragraph-agence_number');

        if(_agenceNumberContainer.length > 0){
          const _bloc = _agenceNumberContainer.find('.agence_number');
          const _count = _agenceNumberContainer.find('.number');

          gsap.registerPlugin(ScrollTrigger);

          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: _agenceNumberContainer,
              start: "top 80%",
              end: "bottom 10%",
              toggleActions: "play none none none"
            }
          });

          tl.from(_bloc, {
            duration: 1, opacity: 0, stagger: 0.25
          }, "<")
            .to(_bloc, {
              duration: 1.5, opacity: 1, stagger: 0.25
            }, "<")
            .from(_count, {
              duration: 2,
              ease:"none",
              innerHTML:"0",
              roundProps:"innerHTML"
            }, "<");
        }
      },

      animateLabContent: function(){
        const _labBloc1 = $('.lab');
        const _labBloc2 = $('.paragraph.background-blue.container-fluid.margin-calc');

        if(_labBloc1.length > 0){
          const _imagesBloc = _labBloc1.find('.lab_images');
          const _textBloc = _labBloc1.find('.lab_text');
          const _img1 = _imagesBloc.find('.lab_images_1');
          const _img2 = _imagesBloc.find('.lab_images_2');
          const _img3 = _imagesBloc.find('.lab_images_3');
          const _img4 = _imagesBloc.find('.lab_images_4');

          gsap.registerPlugin(ScrollTrigger);
              const tl = gsap.timeline({
                scrollTrigger: {
                  trigger: _textBloc,
                  start: "top 80%",
                  end: "bottom 10%",
                  toggleActions: "play none none none"
                }
              });
              tl.from([_img1, _img3], {
                duration: 1, y: "0", stagger: 0
              }, "<")
                .from([_img2, _img4], {
                  duration: 1, y: "-100px", stagger: 0
                }, "<")
                .to([_img1, _img3], {
                  duration: 1, y: "-100px", stagger: 0
                }, "<")
                .to([_img2, _img4], {
                  duration: 1, y: "0", stagger: 0
                }, "<");
        }

        if(_labBloc2.length > 0){
          const _img = _labBloc2.find('.media');
          gsap.registerPlugin(ScrollTrigger);
              const tl = gsap.timeline({
                scrollTrigger: {
                  trigger: _labBloc2,
                  start: "top 80%",
                  end: "bottom 10%",
                  toggleActions: "play none none none"
                }
              });
            tl.from(_img, {
                duration: 1, opacity: 0, scale: 0.8, stagger: 0.15, overwrite: true
            }, "<")
            .to(_img, {
              duration: 1, opacity: 1, scale: 1, stagger: 0.15, overwrite: true
            }, "<");
        }
      },

      animateCaseContent: function(){
        const _contentTextImg   = $('.text_image.paragraph');
        const _contentOneImg    = $('.text_image_one-image');
        const _contentTwoImg    = $('.text_image_two-image');

        if(_contentTextImg.length > 0 ){
          const _media = _contentTextImg.find('.media');
          gsap.registerPlugin(ScrollTrigger);
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: _contentTextImg,
                    start: "top 100%",
                    end: "bottom 10%",
                    toggleActions: "play none none none"
                }
            });
            tl.from(_media, {
                duration: 1, opacity: 0, scale: 0.8, y: "100px", stagger: 0.25
            }, "<")
            .to(_media, {
              duration: 1, opacity: 1, scale:1, y: "0", stagger: 0.25
            }, "<")
            .staggerFromTo(_media, 1, {
                y: 0
              },
              {
                y: 10, ease: Sine.easeInOut, repeat: -1, yoyo: true
              }, .3);
        }

        if(_contentOneImg.length > 0){
          const _media = _contentOneImg.find('.media');
          gsap.registerPlugin(ScrollTrigger);
              const tl = gsap.timeline({
                scrollTrigger: {
                  trigger: _contentOneImg,
                  start: "top 100%",
                  end: "bottom 10%",
                  toggleActions: "play none none none"
                }
              });
              tl.from(_media, {
                duration: 1, opacity: 0, scale: 0.8, y: "-100px", stagger: 0.25
              }, "<")
            .to(_media, {
              duration: 1, opacity: 1, scale:1, y: "0", stagger: 0.25
            }, "<");
        }
        if(_contentTwoImg.length > 0){
          const _media = _contentTwoImg.find('.media');
          gsap.registerPlugin(ScrollTrigger);
              const tl = gsap.timeline({
                scrollTrigger: {
                  trigger: _contentTwoImg,
                  start: "top 100%",
                  end: "bottom 10%",
                  toggleActions: "play none none none"
                }
              });
              tl.from(_media, {
                duration: 1, opacity: 0, y: "100px", stagger: 0.25
              }, "<")
            .to(_media, {
              duration: 1, opacity: 1, y: "0", stagger: 0.25
            }, "<");
        }
      },

      animateIconMouse: function(){
        const _icon = $('.icon-scroll');

        if(_icon.length > 0){
          gsap.registerPlugin(ScrollTrigger);
          const tl = gsap.timeline();

          tl.staggerFromTo(_icon, 1, {
              y: 0,
              x: '-50%'
            },
            {
              y: 10, x: "-50%", ease: Sine.easeInOut, repeat: -1, yoyo: true
            }, .3)
        }
      },

      animateLogo: function(){
        const _containerGrid = $('.anim-container');
        if(_containerGrid.length > 0){
          gsap.registerPlugin(ScrollTrigger);

          _containerGrid.each(function(){
            const _paragraph = $(this);
            const _logos = _paragraph.find('.anim_fade');
            ScrollTrigger.batch(_logos, {
              onEnter: batch => gsap.to(batch, {opacity: 1, stagger: 0.15, duration: .8}),
            });
          });
        }
      },

      animateContent: function(){
        const _contentZoomIn = $('.anim_zoom-in');
        const _contentFadeRight = $('.anim_fade-right');
        const _contentFadeLeft = $('.anim_fade-left');
        const _contentFadeUp = $('.anim_fade-up');
        const _contentFadeDown = $('.anim_fade-down');
        const _contentScaleX = $('.anim_scaleX');

        if(_contentZoomIn.length > 0){
          gsap.registerPlugin(ScrollTrigger);

          ScrollTrigger.batch(_contentZoomIn, {
            onEnter: batch => gsap.to(batch, {duration: 1, opacity: 1, scale: 1, stagger: 0.5, overwrite: true}),
          });
        }

        if(_contentFadeRight.length > 0){
          gsap.registerPlugin(ScrollTrigger);

          ScrollTrigger.batch(_contentFadeRight, {
            onEnter: batch => gsap.to(batch, {duration: 1, opacity: 1, x: 0, stagger: 0.25, overwrite: true}),
          });
        }

        if(_contentFadeLeft.length > 0){
          gsap.registerPlugin(ScrollTrigger);

          ScrollTrigger.batch(_contentFadeLeft, {
            onEnter: batch => gsap.to(batch, {duration: 1, opacity: 1, x: 0, stagger: 0.25, overwrite: true}),
          });
        }

        if(_contentFadeUp.length > 0){
          gsap.registerPlugin(ScrollTrigger);

          ScrollTrigger.batch(_contentFadeUp, {
            onEnter: batch => gsap.to(batch, {duration: 1, opacity: 1, y: 0, stagger: 0.25, overwrite: true}),
          });
        }

        if(_contentFadeDown.length > 0){
          gsap.registerPlugin(ScrollTrigger);

          ScrollTrigger.batch(_contentFadeDown, {
            onEnter: batch => gsap.to(batch, {duration: 1, opacity: 1, y: 0, stagger: 0.25, overwrite: true}),
          });
        }

        if(_contentScaleX.length > 0){
          gsap.registerPlugin(ScrollTrigger);

          ScrollTrigger.batch(_contentScaleX, {
            onEnter: batch => gsap.to(batch, {scaleX: -1, stagger: 0.25, overwrite: true}),
            onLeave: batch => gsap.to(batch, {scaleX: 1, stagger: 0.25, overwrite: true}),
          });
        }
      },

      animateContentIcons: function(){
        const _blocIconRight = $('.anim-side-reverse');
        const _blocIconLeft = $('.anim-side');

        if(_blocIconRight.length > 0){
          _blocIconRight.each(function(){
            const _bloc = $(this);
            const _icon = _bloc.find('.media-icons-big');
            const _iconBg = _bloc.find('.media-icons-big .image_transform');
            gsap.registerPlugin(ScrollTrigger);
            ScrollTrigger.matchMedia({
              "(min-width: 768px)": function() {
                const tl = gsap.timeline({
                  scrollTrigger: {
                    trigger: _bloc,
                    start: "top 80%",
                    end: "bottom 10%",
                    toggleActions: "play none none none",
                  }
                });

                tl.from(_icon, {
                  duration: 1, opacity: 0, x: "100px", stagger: 0.25
                }, "<")
                  .to(_icon, {
                    duration: 1, opacity: 1, x: "0", stagger: 0
                  }, "<")
                  .to(_iconBg, {
                    xPercent:-50, x:10, y:10, duration: 1
                  })
              },
            })
          })
        }

        if(_blocIconLeft.length > 0){
          _blocIconLeft.each(function(){
            const _bloc = $(this);
            const _icon = _bloc.find('.media-icons-big');
            const _iconBg = _bloc.find('.media-icons-big .image_transform');
            gsap.registerPlugin(ScrollTrigger);
            ScrollTrigger.matchMedia({
              "(min-width: 768px)": function() {
                const tl = gsap.timeline({
                  scrollTrigger: {
                    trigger: _bloc,
                    start: "top 80%",
                    end: "bottom 10%",
                    toggleActions: "play none none none",
                  }
                });

                tl.from(_icon, {
                  duration: 1, opacity: 0, x: "-100px", stagger: 0.25
                }, "<")
                  .to(_icon, {
                    duration: 1, opacity: 1, x: "0", stagger: 0
                  }, "<")
                  .to(_iconBg, {
                    xPercent:-50, x:10, y:10, duration: 1
                  })
              },
            })
          })
        }
      },

      teamHover: function (){
        if($('.subskill-member').length > 0){
          if(!app.isMobile){
            $('.subskill-member_image').each(function (){
              $(this).mouseenter(function (e){
                let state = 'in';
                let elem = e.currentTarget;
                let direction = app.getDirection(e, elem);
                let dirClass = '';

                switch (direction) {
                  case 0 : dirClass = '-top'; break;
                  case 1 : dirClass = '-right'; break;
                  case 2 : dirClass = '-bottom'; break;
                  case 3 : dirClass = '-left'; break;
                }

                if ((elem.className.match(/out-\S+/g) || []).join(' ')) {
                  elem.className = elem.className.replace(/out-\S+/g, '')
                }

                if ((elem.className.match(/in-\S+/g) || []).join(' ')) {
                  elem.className = elem.className.replace(/in-\S+/g, '')
                }

                elem.classList.add(state + dirClass)

              });

              $(this).mouseleave(function (e){
                let state = 'out';
                let elem = e.currentTarget;
                let direction = app.getDirection(e, elem);

                let dirClass = '';

                switch (direction) {
                  case 0 : dirClass = '-top'; break;
                  case 1 : dirClass = '-right'; break;
                  case 2 : dirClass = '-bottom'; break;
                  case 3 : dirClass = '-left'; break;
                }

                if ((elem.className.match(/out-\S+/g) || []).join(' ')) {
                  elem.className = elem.className.replace(/out-\S+/g, '')
                }

                if ((elem.className.match(/in-\S+/g) || []).join(' ')) {
                  elem.className = elem.className.replace(/in-\S+/g, '')
                }

                elem.classList.add(state + dirClass)
              });
            });
          }else{
            /*gsap.registerPlugin(ScrollTrigger);
            ScrollTrigger.batch('.subskill-member_image', {
              toggleActions: "play none none none",
              start: "top 60%",
              onEnter: function (images){
                gsap.to(images, {className: 'subskill-member_image hide'});
              }
            });*/
          }
        }
      },

      getDirection: function (event, elem){
        const width = elem.offsetWidth;
        const height = elem.offsetHeight;
        const x = (event.pageX - elem.offsetLeft - (width / 2) * (width > height ? (height / width) : 1));
        const y = (event.pageY - elem.offsetTop - (height / 2) * (height > width ? (width / height) : 1));

        return Math.round(Math.atan2(y, x) / 1.57079633 + 5) % 4;
      },

      pageTransition: function (){

      },

      detectMobile: function (){
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          app.isMobile = true;
        }
      },

      fixedHeader: function (){
        if($(window).scrollTop() > 30){
          $('.header').addClass('fixed');
          $('body').addClass('header-is-fixed');
        }
        $(window).scroll(function() {
          if ($(window).scrollTop() > 30) {
            $('.header').addClass('fixed');
            $('body').addClass('header-is-fixed');
          } else {
            $('.header').removeClass('fixed');
            $('body').removeClass('header-is-fixed');
          }
        });
      },

      burgerMenu: function (){
        $('.burger').on('click', function (){
          $('.burger').toggleClass('open');
          $('body').toggleClass('menu-active');
        });
        $('.menu-close').on('click', function (){
          $('.burger').click();
        });
      },

      animateLines: function (){
        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.batch(".draw", {
          toggleActions: "play none none none",
          start: "top 100%",
          onEnter: function (lines){
            gsap.to(lines, {height: "100%", duration: 1.5});
          }
        });
      },

      animateList: function (){
        if($('.list-container').length > 0){
          gsap.registerPlugin(ScrollTrigger);
          ScrollTrigger.batch(".list-container", {
            toggleActions: "play none none none",
            start: "top bottom",
            onEnter: function (lines){
              gsap.to('.list-container-item', {opacity: 1, y: 0, duration: 1.3, stagger: 1});
            }
          });
        }
      },

      animateClientCase: function (){
        if($('.clients_list-container').length > 0){
          const breakpoint = window.matchMedia( '(max-width:767px)' );

          var tl = gsap.timeline();

          const breakpointChecker = function() {
            if ( breakpoint.matches === true ) {
              $('.client.hasCase').each(function (){
                var $div = $(this).find('.client_case');
                tl.set($div, {
                  scale: 1,
                  x: 0,
                  y: 0,
                  css: {
                    left: 0,
                    top: 0
                  }
                });
              });
              tl.play(0);
              tl.pause();
            } else if ( breakpoint.matches === false ) {
              $('.client.hasCase').each(function (){
                $(this).mouseenter(function (){
                  var $div = $(this).find('.client_case');
                  tl.set($div, {
                    scale: 0,
                    x: '10px',
                    y: '10px'
                  });
                  tl.to($div, 0.4, {scale: 1, autoAlpha: 1});
                  $(this).on('mousemove', function (e){
                    var height = $(this).height();
                    gsap.to($div, 0.3, {
                      css: {
                        left: e.pageX,
                        top: (e.pageY - (height / 2) + 20)
                      }
                    });
                  });
                });
                $(this).mouseleave(function (){
                  var $div = $(this).find('.client_case');
                  tl.to($div,0.4,{scale:0.1,autoAlpha:0})
                });

              });

              tl.play();
            }
          };

          breakpoint.addEventListener('change', breakpointChecker);
          breakpointChecker();

        }
      },

      animateCases: function (){
        if($('.cases_list').length > 0 || $('.clients_list').length > 0){
          const breakpoint = window.matchMedia( '(max-width:767px)' );

          var tl = gsap.timeline();

          const breakpointChecker = function() {
            if ( breakpoint.matches === true ) {
              $('.grid').each(function (){
                var $div = $(this).find('.round');
                console.log($div);
                tl.set($div, {
                  scale: 1,
                  x: 0,
                  y: 0,
                  css: {
                    left: 0,
                    top: 0
                  }
                });
              });
              tl.play(0);
              tl.pause();
            } else if ( breakpoint.matches === false ) {
              $('.grid').each(function (){
                var $div = $(this).find('.round');
                console.log($div);
                $(this).mouseenter(function (){
                  tl.set($div, {
                    scale: 0,
                    x: '10px',
                    y: '10px'
                  });
                  tl.to($div, 0.4, {scale: 1, autoAlpha: 1});
                  $(this).on('mousemove', function (e){
                    var height = $div.height();
                    gsap.to($div, 0.3, {
                      css: {
                        left: e.pageX,
                        top: (e.pageY + (height / 2))
                      }
                    });
                  });
                });
                $(this).mouseleave(function (){
                  tl.to($div,0.4,{scale:0.1,autoAlpha:0})
                });

              });

              tl.play();
            }
          };

          breakpoint.addEventListener('change', breakpointChecker);
          breakpointChecker();

        }
      },

      animateImgTest: function(){
        gsap.registerPlugin(ScrollTrigger);
        const _paragraph = $('.paragraph .grid.large');
        if(_paragraph.length > 0){
          // console.log(_caseTextImg);
          let _containerImg = _paragraph.find('.reveal');
          let _img = _containerImg.find('img');
          console.log(_containerImg, _img);

          let tl = gsap.timeline({
            scrollTrigger: {
              trigger: _containerImg,
              toggleActions: "restart none none reset"
            }
          });

          tl.set(_containerImg, { autoAlpha: 1 });
          tl.from(_containerImg, 1.5, {
            xPercent: -100,
            ease: Power2.out
          });

          tl.from(_img, 1.5, {
            xPercent: 100,
            scale: 1.3,
            delay: -1.5,
            ease: Power2.out
          });
        }
      },

      animateIcons: function (){
        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.batch(".media-icons .image_transform", {
          toggleActions: "play none none none",
          start: "top bottom",
          onEnter: function (images){
            gsap.to(images, {xPercent:-50, yPercent:-56, x:10, y:10, duration: 1.5});
          }
        });
      },

      animateIconsBig: function (){
        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.batch(".media-icons-big .image_transform", {
          toggleActions: "play none none none",
          start: "top bottom",
          onEnter: function (images){
            gsap.to(images, {xPercent:-50, x:10, y:10, duration: 1.5});
          }
        });
      },

      swiperRealisation: function (){
        if( $('.swiper-realisation').length > 0 ){
          let mySwiper;
          let sliders = document.querySelectorAll('.swiper-realisation');
          sliders.forEach((slider, index)=>{
                let _id = slider.id;
                mySwiper = new Swiper(`#${_id}`, {
                    loop: false,
                    scrollbar: {
                        el: `#${_id} .swiper-footer .swiper-scrollbar`,
                        draggable: true
                    },
                    navigation: {
                        nextEl: `#${_id} .swiper-button-next`,
                        prevEl: `#${_id} .swiper-button-prev`
                    },
                    freeMode: true,
                    mousewheel: {
                        forceToAxis: true
                    },
                    speed: 800,
                    slidesPerView: 3,
                    spaceBetween: 30,
                    breakpoints: {
                        991: {
                            slidesPerView: 3,
                            spaceBetween: 30
                        },
                        767: {
                            slidesPerView: 2.5,
                            spaceBetween: 30
                        },
                        575: {
                            slidesPerView: 2.5,
                            spaceBetween: 30
                        },
                        320: {
                            slidesPerView: 1.3,
                            spaceBetween: 30
                        }
                    }
                });
                mySwiper.on('transitionStart', function (){
                    if($(`#${_id} .swiper-wrapper .swiper-slide-prev`).length > 0){
                        const drawResetPrev = document.querySelector(`#${_id} .swiper-wrapper .swiper-slide-prev .draw`);
                        gsap.set([drawResetPrev], {height: 0});
                    }
                    if($(`#${_id} .swiper-wrapper .swiper-slide-next`).length > 0){
                        const drawResetNext = document.querySelector(`#${_id} .swiper-wrapper .swiper-slide-next .draw`);
                        gsap.set([drawResetNext], {height: 0});
                    }
                    if($(`#${_id} .swiper-wrapper .swiper-slide-active`).length > 0){
                        const drawResetActive = document.querySelector(`#${_id} .swiper-wrapper .swiper-slide-active .draw`);
                        gsap.set([drawResetActive], {height: 0});
                    }
                });
                mySwiper.on('transitionEnd', function (){
                    const draw = document.querySelector(`#${_id} .swiper-wrapper .swiper-slide-active .draw`);
                    gsap.timeline({paused:true})
                        .set(draw, {height: 0})
                        .to(draw, 1.5, {height: "100%"})
                        .play(0);
                });
                mySwiper.on('reachEnd', function (){
                    const draw = document.querySelector(`#${_id} .swiper-wrapper .swiper-slide-next .draw`);
                    gsap.timeline({paused:true})
                        .set(draw, {height: 0})
                        .to(draw, 1.5, {height: "100%"})
                        .play(0);
                });
            });
        }
      },

      swiperProjects: function (){
        if( $('.swiper-projects').length > 0 ){
            const breakpoint = window.matchMedia( '(min-width:992px)' );

            const breakpointChecker = function() {
                if ( breakpoint.matches === true ) {
                    if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
                    $('.swiper-projects .swiper-wrapper').addClass('row');
                    const drawReset = document.querySelector('.swiper-projects .swiper-wrapper .swiper-slide .draw');
                    gsap.set([drawReset], {height: 0});
                    return;
                } else if ( breakpoint.matches === false ) {
                    $('.swiper-projects .swiper-wrapper').removeClass('row');
                    return enableSwiper();
                }
            };
          let mySwiper;
          let sliders = document.querySelectorAll('.swiper-projects');
          const enableSwiper = function() {
            sliders.forEach((slider, index)=>{
                let _id = slider.id;
                mySwiper = new Swiper(`#${_id}`, {
                    loop: false,
                    scrollbar: {
                        el: `#${_id} .swiper-footer .swiper-scrollbar`,
                        draggable: true
                    },
                    navigation: {
                        nextEl: `#${_id} .swiper-button-next`,
                        prevEl: `#${_id} .swiper-button-prev`
                    },
                    freeMode: true,
                    mousewheel: {
                        forceToAxis: true
                    },
                    speed: 800,
                    slidesPerView: 3,
                    spaceBetween: 30,
                    breakpoints: {
                        991: {
                            slidesPerView: 3,
                            spaceBetween: 30
                        },
                        767: {
                            slidesPerView: 2.5,
                            spaceBetween: 30
                        },
                        575: {
                            slidesPerView: 2.5,
                            spaceBetween: 30
                        },
                        320: {
                            slidesPerView: 1.3,
                            spaceBetween: 30
                        }
                    }
                });
                mySwiper.on('transitionStart', function (){
                    if($(`#${_id} .swiper-wrapper .swiper-slide-prev`).length > 0){
                        const drawResetPrev = document.querySelector(`#${_id} .swiper-wrapper .swiper-slide-prev .draw`);
                        gsap.set([drawResetPrev], {height: 0});
                    }
                    if($(`#${_id} .swiper-wrapper .swiper-slide-next`).length > 0){
                        const drawResetNext = document.querySelector(`#${_id} .swiper-wrapper .swiper-slide-next .draw`);
                        gsap.set([drawResetNext], {height: 0});
                    }
                    if($(`#${_id} .swiper-wrapper .swiper-slide-active`).length > 0){
                        const drawResetActive = document.querySelector(`#${_id} .swiper-wrapper .swiper-slide-active .draw`);
                        gsap.set([drawResetActive], {height: 0});
                    }
                });
                mySwiper.on('transitionEnd', function (){
                    const draw = document.querySelector(`#${_id} .swiper-wrapper .swiper-slide-active .draw`);
                    gsap.timeline({paused:true})
                        .set(draw, {height: 0})
                        .to(draw, 1.5, {height: "100%"})
                        .play(0);
                });
                mySwiper.on('reachEnd', function (){
                    const draw = document.querySelector(`#${_id} .swiper-wrapper .swiper-slide-next .draw`);
                    gsap.timeline({paused:true})
                        .set(draw, {height: 0})
                        .to(draw, 1.5, {height: "100%"})
                        .play(0);
                });
            });
          };
          breakpoint.addEventListener('change', breakpointChecker);
          breakpointChecker();
        }
      },

      swiperExpertise: function (){
        if($('.swiper-expertise').length > 0){
          const breakpoint = window.matchMedia( '(min-width:992px)' );

          let mySwiper;

          const breakpointChecker = function() {
            if ( breakpoint.matches === true ) {
              if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
              $('.swiper-expertise .swiper-wrapper').addClass('row');
              const drawReset = document.querySelector('.swiper-expertise .swiper-wrapper .swiper-slide .draw');
              gsap.set([drawReset], {height: 0});
              return;
            } else if ( breakpoint.matches === false ) {
              $('.swiper-expertise .swiper-wrapper').removeClass('row');
              return enableSwiper();
            }
          };

          const enableSwiper = function() {
            mySwiper = new Swiper('.swiper-expertise', {
              loop: false,
              scrollbar: {
                el: '.swiper-footer .swiper-scrollbar',
                draggable: true,
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              freeMode: true,
              mousewheel: {
                forceToAxis: true,
              },
              speed: 800,
              breakpoints: {
                991: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
                767: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                575: {
                  slidesPerView: 1.5,
                  spaceBetween: 30,
                },
                320: {
                  slidesPerView: 1.3,
                  spaceBetween: 30,
                }
              }
            });
            mySwiper.on('transitionStart', function (){
              if($('.swiper-expertise .swiper-wrapper .swiper-slide-prev').length > 0){
                const drawResetPrev = document.querySelector('.swiper-expertise .swiper-wrapper .swiper-slide-prev .draw');
                gsap.set([drawResetPrev], {height: 0});
              }
              if($('.swiper-expertise .swiper-wrapper .swiper-slide-next').length > 0){
                const drawResetNext = document.querySelector('.swiper-expertise .swiper-wrapper .swiper-slide-next .draw');
                gsap.set([drawResetNext], {height: 0});
              }
              if($('.swiper-expertise .swiper-wrapper .swiper-slide-active').length > 0){
                const drawResetActive = document.querySelector('.swiper-expertise .swiper-wrapper .swiper-slide-active .draw');
                gsap.set([drawResetActive], {height: 0});
              }
            });
            mySwiper.on('transitionEnd', function (){
              const draw = document.querySelector('.swiper-expertise .swiper-wrapper .swiper-slide-active .draw');
              gsap.timeline({paused:true})
                .set(draw, {height: 0})
                .to(draw, 1.5, {height: "100%"})
                .play(0);
            });
            mySwiper.on('reachEnd', function (){
              const draw = document.querySelector('.swiper-expertise .swiper-wrapper .swiper-slide-next .draw');
              gsap.timeline({paused:true})
                .set(draw, {height: 0})
                .to(draw, 1.5, {height: "100%"})
                .play(0);
            });
          };
          breakpoint.addEventListener('change', breakpointChecker);
          breakpointChecker();
        }
      },

      swiperArticles: function (){
        if($('.swiper-articles').length > 0){
          var mySwiper = new Swiper('.swiper-articles', {
            loop: false,
            scrollbar: {
              el: '.swiper-footer .swiper-scrollbar',
              draggable: true,
            },
            centerInsufficientSlides: true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            freeMode: true,
            mousewheel: {
              forceToAxis: true,
            },
            speed: 800,
            breakpoints: {
              991: {
                slidesPerView: 3,
                spaceBetween: 15,
              },
              767: {
                slidesPerView: 2,
                spaceBetween: 5,
              },
              575: {
                slidesPerView: 2,
                spaceBetween: 5,
              },
              320: {
                slidesPerView: 1.3,
                spaceBetween: 5,
              }
            }
          })
        }
      },

      swiperActualites: function (){
        if($('.swiper-actualites').length > 0){
          var mySwiper = new Swiper('.swiper-actualites', {
            loop: false,
            scrollbar: {
              el: '.swiper-footer .swiper-scrollbar',
              draggable: true,
            },
            centerInsufficientSlides: true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            freeMode: true,
            mousewheel: {
              forceToAxis: true,
            },
            speed: 800,
            breakpoints: {
              991: {
                slidesPerView: 3.5,
                spaceBetween: 70,
              },
              767: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              575: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
              320: {
                slidesPerView: 1.3,
                spaceBetween: 30,
              }
            }
          })
        }
      },

      swiperCases: function (){
        if($('.swiper-cases').length > 0){
          const breakpoint = window.matchMedia( '(min-width:992px)' );

          let mySwiper;

          const breakpointChecker = function() {
            if ( breakpoint.matches === true ) {
              if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
              $('.swiper-cases .swiper-wrapper').addClass('row');
              const drawReset = document.querySelector('.swiper-cases .swiper-wrapper .swiper-slide .draw');
              gsap.set([drawReset], {height: "100%"});
              return;
            } else if ( breakpoint.matches === false ) {
              $('.swiper-cases .swiper-wrapper').removeClass('row');
              return enableSwiper();
            }
          };
          const enableSwiper = function() {
            mySwiper = new Swiper ('.swiper-cases', {
              loop: false,
              slidesPerView: 1.4,
              spaceBetween: 30,
              speed: 800,
              scrollbar: {
                el: '.swiper-footer .swiper-scrollbar',
                draggable: true,
              },
              freeMode: true,
              mousewheel: {
                forceToAxis: true,
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            });
            mySwiper.on('transitionStart', function (){
              if($('.swiper-cases .swiper-wrapper .swiper-slide-prev').length > 0){
                const drawResetPrev = document.querySelector('.swiper-cases .swiper-wrapper .swiper-slide-prev .draw');
                gsap.set([drawResetPrev], {height: 0});
              }
              if($('.swiper-cases .swiper-wrapper .swiper-slide-next').length > 0){
                const drawResetNext = document.querySelector('.swiper-cases .swiper-wrapper .swiper-slide-next .draw');
                gsap.set([drawResetNext], {height: 0});
              }
              if($('.swiper-cases .swiper-wrapper .swiper-slide-active').length > 0){
                const drawResetActive = document.querySelector('.swiper-cases .swiper-wrapper .swiper-slide-active .draw');
                gsap.set([drawResetActive], {height: 0});
              }
            });
            mySwiper.on('transitionEnd', function (){
              const draw = document.querySelector('.swiper-cases .swiper-wrapper .swiper-slide-active .draw');
              gsap.timeline({paused:true})
                .set(draw, {height: 0})
                .to(draw, 1.5, {height: "100%"})
                .play(0);
            });
            mySwiper.on('reachEnd', function (){
              const draw = document.querySelector('.swiper-cases .swiper-wrapper .swiper-slide-next .draw');
              gsap.timeline({paused:true})
                .set(draw, {height: 0})
                .to(draw, 1.5, {height: "100%"})
                .play(0);
            });

          };
          breakpoint.addEventListener('change', breakpointChecker);
          breakpointChecker();
        }
      },

      swiperLogo: function (){
        if($('.swiper-logo').length > 0){
          const breakpoint = window.matchMedia( '(min-width:992px)' );

          let mySwiper;

          const breakpointChecker = function() {
            if ( breakpoint.matches === true ) {
              if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
              $('.swiper-logo .swiper-wrapper').addClass('row');
              return;
            } else if ( breakpoint.matches === false ) {
              $('.swiper-logo .swiper-wrapper').removeClass('row');
              return enableSwiper();
            }
          };
          const enableSwiper = function() {
            mySwiper = new Swiper ('.swiper-logo', {
              loop: false,
              slidesPerView: 2.5,
              spaceBetween: 15,
              speed: 800,
              freeMode: true,
              mousewheel: {
                forceToAxis: true,
              },
              scrollbar: {
                el: '.swiper-footer .swiper-scrollbar',
                draggable: true,
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            });
          };
          breakpoint.addEventListener('change', breakpointChecker);
          breakpointChecker();
        }
      }

    };
    app.init();
  });
})(jQuery);
